import { TableCellImage } from 'src/components/table-cell-image';

export default TableCellImage;
